import { FC } from 'react';
import { twMerge } from 'tailwind-merge';

type CampaignSummaryItemLabelProps = {
  text: string;
  className?: string;
};

export const CampaignSummaryItemLabel: FC<CampaignSummaryItemLabelProps> = ({ text, className }) => {
  return (
    <span className={twMerge('px-2 py-0.5 text-xs rounded-full border border-success-200 text-success-700 bg-success-50 size-fit text-nowrap', className)}>
      <p className='first-letter:capitalize'>{text}</p>
    </span>
  );
};
